import Vue from 'vue';
const resource = '/images';

export default {
  // CUSTOM ENDPOINT
  getQRCode(payload) {
    return Vue.prototype.$axiosMainClient.get(`${resource}/qrcode`, {
      params: payload,
    });
  },
};
